<template>
  <v-layout row wrap class="align-center justify-center">
    <v-tabs>
      <v-tab href="#fleetlevel">Ralatório de Frota</v-tab>
      <v-tab href="#bases">Ralatório de Bases</v-tab>

      <v-tab-item value="fleetlevel">
        <v-layout row wrap class="align-center justify-center">
          <v-spacer />
          <v-flex xs4>
            <bar-chart
              class="pa-5"
              ref="chart1"
              :chart-data="datacollection"
              :options="options"
            ></bar-chart>
          </v-flex>
          <v-spacer />
          <v-flex xs4>
            <bar-chart
              lass="pa-5"
              :chart-data="datacollection2"
              :options="options2"
            ></bar-chart>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-tab-item>

      <v-tab-item value="bases">
        <div v-for="(grafico, index) in graficos" :key="index+1">
          <v-card-title>{{grafico.key}}</v-card-title>
          <v-data-table
            hide-default-header
            hide-default-footer
            :headers="all"
            :items="grafico.ambulances"
            :items-per-page="-1"
            class="elevation-1"
          >
            <template v-slot:header="{}">
              <thead>
              <tr>
                <th class="text-start grey lighten-2">Bases</th>
                <th class="text-center grey lighten-2">Total</th>
                <th class="text-center grey lighten-2">Ativos</th>
                <th class="text-center grey lighten-2">Inativos</th>
              </tr>
              </thead>
            </template>
            <template v-slot:[`item.name`]="{ item }"><div >{{item.name_base}}</div></template>
            <template v-slot:[`item.total`]="{ item }"><div >{{item.ativos+item.inativos}}</div></template>
            <template v-slot:[`item.ativos`]="{ item }"><div >{{item.ativos}}</div></template>
            <template v-slot:[`item.inativos`]="{ item }"><div >{{item.inativos}}</div></template>
          </v-data-table>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import BarChart from "../../Charts/BarChart";
export default {
  components: {BarChart},
  data: () =>({
    datacollection: {
      labels: [],
      datasets: [
        {
          label: 'Total de Ambulâncias Ativas',
          backgroundColor: 'green',
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: '#249EBF',
          data: []
        }
      ]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: true
          }
        }],
        xAxes: [{
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: false
          }
        }]
      },
      legend: {
        display: true
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function(tooltipItems, data) {
            return tooltipItems.yLabel;
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      height: 200,
    },
    datacollection2: {
      labels: [],
      datasets: [
        {
          label: 'Total de Ambulâncias Paradas',
          backgroundColor: 'red',
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: '#249EBF',
          data: []
        }
      ]
    },
    options2: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: true
          }
        }],
        xAxes: [{
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: false
          }
        }]
      },
      legend: {
        display: true
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function(tooltipItems, data) {
            return tooltipItems.yLabel;
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      height: 200,
    },
    all: [
      { text: 'Bases',align: 'start', sortable: false, value: 'name'},
      { text: 'Total', value: 'total', sortable: false, align: 'center' },
      { text: 'Ativos', value: 'ativos', sortable: false, align: 'center' },
      { text: 'Inativos', value: 'inativos', sortable: false, align: 'center' },

    ],
    graficos:[]
  }),
  created (){
    this.initialize();
  },
  async initialize (){
    await this.$store.dispatch("downloadAmbulance")
  },
  async mounted(){
    let copy = await this.$store.getters.ambulances
    let array = copy.reduce((objetoFinal, consultaAtual ) => {
      if(!objetoFinal[consultaAtual.status]) objetoFinal[consultaAtual.status] = []
      objetoFinal[consultaAtual.status].push(consultaAtual);
      return objetoFinal
    }, {})
    let keys = Object.keys(array);
    keys.forEach((key) =>{
      array[key] = array[key].reduce((objetoFinal, consultaAtual ) => {
        if(!objetoFinal[consultaAtual.type]) objetoFinal[consultaAtual.type] = []
        objetoFinal[consultaAtual.type].push(consultaAtual);
        return objetoFinal
      }, {})
    })
    for(let item in array){
      if(item === '0'){
        for (let type in array[item]){
          this.datacollection2.labels.push(type)
          this.datacollection2.datasets[0].data.push(array[item][type].length)
        }
      } else {
        for (let type in array[item]){
          this.datacollection.labels.push(type)
          this.datacollection.datasets[0].data.push(array[item][type].length)
        }
      }
    }
    let ambulances = await this.$store.dispatch('downloadAmbulance').then( resolve => resolve.data );
    let bases = await this.$store.dispatch('downloadBases').then( resolve => resolve.data.bases );
    let graficos = { }
    bases.forEach( base => {
      base.ambulances.forEach( ambulance => {
        if(!graficos[ambulance.type]){
          graficos[ambulance.type] = { inativos: 0, ativos: 0, ambulances:{} }
        }
        if(!graficos[ambulance.type].ambulances[base.name]){
          graficos[ambulance.type].ambulances[base.name] = { inativos: 0, ativos: 0 }
        }

        if(ambulance.status===0){
          graficos[ambulance.type].inativos ++;
          graficos[ambulance.type].ambulances[base.name].inativos++;
        } else {
          graficos[ambulance.type].ativos ++;
          graficos[ambulance.type].ambulances[base.name].ativos++;
        }
      })
    })
    let graficos_base = Object.entries(graficos).map( ([key,value])=>{
      ambulances = Object.entries(value.ambulances).map( ([key,ambulance]) => {
        return { name_base: key, ativos: ambulance.ativos, inativos: ambulance.inativos }
      } )
      return { key:key, ambulances }
    } );
    this.graficos = graficos_base;
    if(this.$refs.chart1){
      this.$refs.chart1.renderChart(this.datacollection, this.options)
    }

  },
  computed: {
    bases (){
      let bases = this.$store.getters.bases;
      return bases
    },
  }
}
</script>
